<template>
<div class="sug-select-imei">
  <popup
    ref="popup"
    class="full-page"
    fullScreen
    :visible="true">
    <!-- 搜索框 -->
    <div class="search-bar">
      <div class="search-input">
        <span class="icon-outlined_back_android cancel-btn" @click="hide"></span>
        <div class="search-input-box">
          <rich-input-box
            v-model="keyword"
            :placeholder="gettext('请输入')"
            clearable
          >
            <i class="crm-outline_search richic-search" slot="prepend"></i>
          </rich-input-box>
        </div>
      </div>
      <!-- <span class="cancel-btn" @click="hide">{{gettext('取消')}}</span> -->
    </div>
    <!-- 搜索结果 -->
    <div class="search-result" v-show="keyword">
      <rich-loading v-show="loading"></rich-loading>
      <div class="search-scroll-wrap" v-if="!loading">
        <rich-result-page
          type="empty"
          v-show="result.length === 0"
        />
        <rich-scroll ref="searchScroll" v-if="result.length > 0">
          <div class="search-list-inner-wrap">
            <ul class="search-list">
              <li
                class="search-list-item"
                v-for="(item, index) in result"
                :key="index">
                <rich-cell
                  :key="index"
                  :title="item.imei"
                  @click="clickSearchItem(item)"
                />
              </li>
              <slot></slot>
            </ul>
          </div>
        </rich-scroll>
      </div>
    </div>
  </popup>
</div>
</template>
<script>
import popup from './Popup'
import { request } from '@/common/utils/request'
import { debounce } from '@/common/utils/util'

export default {
  name: 'SugSelImei',
  components: {
    popup
  },
  data () {
    return {
      isFirstSearch: true,
      loading: false,
      keyword: '',
      result: [],

      loaded: false,
      activeIndex: -1
    }
  },
  watch: {
    keyword (nVal) {
      if (nVal) {
        this.loading = true
        this.searchHandler(nVal)
      }
    }
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
      setTimeout(() => {
        this.remove()
      }, 200)
    },
    searchHandler: debounce(async function (keyword) {
      request.get({
        url: 'crm.bdapp.bizopp.getImeiSug',
        params: {
          keyWord: keyword
        }
      }).then(res => {
        this.result = res.data || []
      }).finally(() => {
        this.loading = false
      })
    }, 800),
    clickSearchItem (item) {
      this.$emit('select', item.imei)
      this.keyword = ''
    }
  }
}
</script>

<style lang="scss">
.sug-select-imei {
  overflow: hidden;
  height: 100%;
  position: relative;
  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }
  .search-bar {
    position: relative;
    align-items: center;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    z-index: 1;
    height: 100px;
    margin-top: var(--barheight);
    background: #FFF;
    // .rich-input {
    //   width: 100%;
    //   background-color: $color-col-line;
    //   color: $color-light-grey;
    //   &::placeholder {
    //     color: $color-light-grey;
    //   }
    // }
    .cancel-btn {
      padding: 10px;
      cursor: pointer;
      padding-right: 24px;
      font-size: $fontsize-large-xx;
      color: #000;
    }
    .search-input {
      // background: $color-col-line;
      // height: 80px;
      display: flex;
      flex: 1;
      align-items: center;
      .search-input-box {
        flex: 1;
        .richic-search {
          font-size: 37px;
          color: #666;
          padding: 0 13px;
        }
      }
      .rich-input-box-bottom {
        padding: 0;
      }
      .rich-input-wrapper .rich-input-field {
        background: #E9EAEE;
        border-radius: 0 8px 8px 0;
      }

      .rich-input-box {
        height: 72px;
        background: #e9eaee;
        border-radius: 8px;

        &::after {
          border-color: transparent !important;
        }

        .icon-v2-outline_search {
          width: 36px;
          height: 36px;
          font-size: 36px;
          margin: 0 13px;
          color: #666666;
        }

        input {
          outline: none;
          height: 72px;
          font-size: 28px;
          appearance: none;
           &::-webkit-input-placeholder {
             font-size: 28px;
             font-family: DiDiSans-Pro-Regular;
             color: #999999;
             letter-spacing: 0;
             line-height: 36px;
             font-weight: normal;
           }
        }

        &.rich-input-box_active {
          &::after {
            content: "";
            border-color: transparent;
          }
          border: none;
        }
      }
      .rich-input-box-prepend {
        margin: 0;
        .filter-button {
          padding: 0;
        }
        .title {
          width: 195px;
          font-family: PingFangSC-Regular;
          font-size: 28px;
          color: #595C66;
          font-weight: 400;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .rich-loading-spinners {
    margin: 30px auto;
  }
  .search-result {
    .search-list-item {
      .rich-cell-title {
        text-align: left;
      }
    }
  }
  .search-scroll-wrap {
    position: absolute;
    top: 100px;
    bottom: 0;
    width: 100%;
    .search-list-inner-wrap {
      padding-bottom: 60px;
    }
  }
  .search-list {
    padding: 0 20px;
  }
}
</style>
